import React from "react";
import { Table, Pagination } from "antd";
import { ApplicationStatus } from "../Application/ApplicationStatus";
import { Link } from "react-router-dom";
import moment from "moment";

const { Column } = Table;

export default function DashboardTable(props) {
    const { loading, applicationList, count, currentPage } = props;
    const formatAddress = (addr) => {
        if (!addr) return null;
        if (addr.streetAddress) {
            const street = addr.streetAddress.length > 15
                ? `${addr.streetAddress.slice(0, 15)}...`
                : addr.streetAddress;
            return addr.city ? `${street}, ${addr.city}` : street;
        }
        return null
    };

    return (
        <>
            <Table
                dataSource={applicationList}
                pagination={false}
                rowKey="_id"
                loading={loading}
                width="100%"
            >
                <Column
                    title="DBA Name"
                    key="dbaName"
                    dataIndex={("_id", "dbaName")}
                    render={(_, record) => {
                        return (
                            <Link
                                to={`/application/view?id=${record._id}`}
                                style={{ margin: "5px" }}
                            >
                                {record.dbaName}
                            </Link>
                        );
                    }}
                />
                <Column title="MID" key="mid" dataIndex="mid" />
                <Column title="Type" key="type" dataIndex="type" />
                <Column title="Owner" key="fullName" dataIndex="fullName" />

                <Column
                    title="Address"
                    key="dbaAddress"
                    dataIndex="dbaAddress"
                    render={(dbaAddressObject, record) => formatAddress(dbaAddressObject) ?? record.googleLink ?? "—"}
                />

                <Column title="By" key="createdBy" dataIndex="createdBy" />
                <Column
                    title="Status"
                    dataIndex="status"
                    key="status"
                    render={(status) => {
                        return <ApplicationStatus status={status} />;
                    }}
                />

                <Column
                    key="createdAt"
                    title="Date"
                    dataIndex={"createdAt"}
                    render={(createdAt) => {
                        return <div> {moment(createdAt).format("MMM DD, YY")}</div>;
                    }}
                />
            </Table>
            {count > 0 && <Pagination defaultCurrent={currentPage} total={count} pageSize={10} onChange={(page) => props.goToPage(page)} />}
        </>
    );
}
